import api from './api';

const expenditureService = {
  getAllExpenditures: async (filters = {}) => {
    const params = new URLSearchParams();
    if (filters.category) params.append('category', filters.category);
    if (filters.from_date) params.append('from_date', filters.from_date);
    if (filters.to_date) params.append('to_date', filters.to_date);
    const response = await api.get(`/api/expenditures?${params}`);
    return response.data;
  },

  createExpenditure: async (data) => {
    const response = await api.post('/api/expenditures', data);
    return response.data;
  },

  deleteExpenditure: async (id) => {
    const response = await api.delete(`/api/expenditures/${id}`);
    return response.data;
  },

  getStats: async () => {
    const response = await api.get('/api/expenditures/stats');
    return response.data;
  },

  updateExpenditure: async (id, data) => {
    const response = await api.put(`/api/expenditures/${id}`, data);
    return response.data;
  },
};

export default expenditureService;